import React, {FC} from "react";
import {IconDefinition} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const ContextMenuOption: FC<{ icon: IconDefinition, text: string, close: () => void, onClick: () => void, style?: 'primary'|'danger' }> = props => {

  const style = {
    primary: 'text-blue-800',
    danger: 'text-red-600',
  }[props.style!] || 'text-blue-800'

  return <div
    onClick={(e) => {
      e.stopPropagation()
      props.onClick()
      props.close()
    }}
  >
    <div className={`flex items-center h-10 px-2 ${style} rounded-xs font-medium hover:bg-slate-100 hover:cursor-pointer`}>
      <FontAwesomeIcon icon={props.icon} className={'mr-1 w-6'}/>
      <span>{props.text}</span>
    </div>
  </div>
}